module.exports = __webpack_public_path__ + "media/bootstrap-icons/list-ol-373d13ca.svg";